import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import OmniSearch from './OmniSearch/OmniSearch.container';
import OmniSearchV4 from './OmniSearchV4/OmniSearch.container';

const OmniSearchToggle = (props) => {
  const { webAppFtMuiV6OmniSearch20251, webAppFtOmniSearch202506 } = useFlags();
  if (webAppFtOmniSearch202506) return null;
  return webAppFtMuiV6OmniSearch20251 ? (
    <OmniSearch {...props} />
  ) : (
    <OmniSearchV4 {...props} />
  );
};

export default OmniSearchToggle;
